<template>
  <nav
    class="mobile-side-menu-container fixed inset-0 font-rubik"
    role="dialog"
    aria-modal="true"
    aria-label="Mobile navigation menu"
  >
    <div
      class="mobile-side-menu fixed top-0 left-0 bg-white h-full"
      :style="{ width: '90%' }"
    >
      <div class="menu-content" role="menu">
        <div
          v-for="([key, item], index) in dropdownEntries"
          :key="key"
          class="menu-item"
        >
          <button
            type="button"
            class="w-full flex items-center justify-between p-4"
            :class="{
              'border-b':
                activeDropdown !== item.name &&
                index !== dropdownEntries.length - 1,
            }"
            :aria-expanded="activeDropdown === item.name"
            :aria-controls="`panel-${key}`"
            @click="toggleDropdown(item.name)"
          >
            <span class="dropdown-title">
              {{ item.name.toUpperCase() }}
            </span>
            <img
              src="@/images/header/drop-down-arrow.svg"
              alt=""
              aria-hidden="true"
              class="arrow-icon"
              :class="{
                'rotate-up': activeDropdown === item.name,
                'rotate-down': activeDropdown !== item.name,
              }"
            />
          </button>

          <div
            v-if="activeDropdown === item.name"
            :id="`panel-${key}`"
            class="menu-dropdown"
          >
            <ul>
              <li
                v-for="(link, idx) in item.links"
                :key="idx"
                class="px-4 py-3 pl-8"
              >
                <a
                  class="dropdown-link flex items-center"
                  :href="link.slug"
                  role="menuitem"
                  @click="closeDropdown"
                >
                  <span
                    class="dropdown-link-name"
                    :class="{ 'always-blue': link.slug === '/service-areas' }"
                  >
                    {{ link.title }}
                  </span>
                  <img
                    src="@/images/service-area-cards/arrow-outward.svg"
                    alt=""
                    aria-hidden="true"
                    class="h-4 ml-1"
                  />
                </a>
              </li>

              <li v-if="item.seeAll" class="flex items-center gap-2 pl-4 py-3">
                <a
                  class="see-all-link"
                  :href="item.seeAll.slug"
                  role="menuitem"
                  @click="closeDropdown"
                >
                  Learn More
                </a>
                <img
                  src="@/images/header/chevron-right.svg"
                  alt=""
                  aria-hidden="true"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="button-container flex justify-between px-4 py-4">
        <a
          :href="`tel:${formattedPhoneNumber}`"
          class="call-us-button flex-1 mr-2 py-3 rounded-full flex justify-center items-center"
        >
          Call Us
        </a>
        <button
          type="button"
          class="get-quote-button flex-1 ml-2 py-3 rounded-full flex justify-center items-center"
          data-vue-init="lead-flow"
          data-props='{ "gtag": "get_quote"}'
        >
          Get Quote
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'MobileSideMenu',
  props: {
    dropdownLinks: {
      type: Object,
      required: true
    },
    organizationPhone: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activeDropdown: null
    }
  },
  computed: {
    // Convert dropdownLinks object into an array of entries to access index
    dropdownEntries() {
      return Object.entries(this.dropdownLinks)
    },
    formattedPhoneNumber() {
      return this.organizationPhone || '1234567890'
    }
  },
  methods: {
    toggleDropdown(name) {      
      this.activeDropdown = this.activeDropdown === name ? null : name
    },
    closeDropdown() {
      this.activeDropdown = null
    }
  }
}
</script>

<style scoped>
.mobile-side-menu-container {
  z-index: 49;
}

.mobile-side-menu {
  margin-top: 60px;
  z-index: 50;
  overflow-y: auto;
  position: relative;
}

.menu-content {
  border-top: 1px solid #e5e7eb;
  padding-bottom: 80px;
}

.rotate-down {
  transform: rotate(180deg);
}

.rotate-up {
  transform: rotate(0deg);
}

.arrow-icon {
  transition: transform 0.2s;
}

.dropdown-title {
  font-size: 14px;
  font-weight: 500;
  line-height: 12px;
  letter-spacing: 0.02em;
  color: #334155;
}

.dropdown-link {
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.dropdown-link-name {
  font-size: 14px;
  font-weight: 400;
  line-height: 10px;
  color: #334155 !important;
}

.always-blue {
  color: #1049FB !important;
}

.dropdown-link img {
  padding: 2px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 50%;
}

.dropdown-link:hover img {
  padding: 2px;
  background-color: white;
  transform: rotate(45deg);
  box-shadow: 0 0 0 1px white;
}

.see-all-link {
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: -0.04em;
  color: #334155 !important;
}

.button-container {
  border-top: 1px solid #e5e7eb;
  position: absolute;
  bottom: 60px;
  width: 100%;
  background-color: white;
}

.call-us-button,
.get-quote-button {
  height: 40px;
  width: 140px;
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: -0.04em;
}

.call-us-button {
  color: #3565FC;
  border: 1px solid #3565FC;
}

.get-quote-button {
  color: white;
  background-color: #3565FC;
}

.call-us-button:hover,
.get-quote-button:hover {
  opacity: 0.9;
}

</style>
